import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import DeleteBlockedDialog from "@common/components/deleteBlockedDialog/DeleteBlockedDialog";
import { useTranslation } from "@localization/useTranslation";
import { ExternalUserViewModel } from "../ExternalUser.types";
import { externalUserBlockerTranslationKeys } from "./DeleteExternalUserDialog.types";
import { useDeleteExternalUserDialogHook } from "./DeleteExternalUserDialog.hooks";

export interface IDeleteExternalUserDialogProps {
    selectedExternalUser: ExternalUserViewModel;
    onCloseDialog: () => void;
    onDeletion: () => void;
}

export function DeleteExternalUserDialog(props: IDeleteExternalUserDialogProps) {
    const { translateString } = useTranslation();
    const { removeExternalUser, inProgress, blockedDeletion } = useDeleteExternalUserDialogHook(props);

    if (blockedDeletion) {
        return (
            <DeleteBlockedDialog
                header={translateString("externalUserCannotBeDeletedHeader")}
                description={translateString("externalUserCannotBeDeletedDescription", { name: props.selectedExternalUser.fullName })}
                blockers={blockedDeletion.blockers}
                blockerTranslationKeys={externalUserBlockerTranslationKeys}
                onDialogClose={props.onCloseDialog}
            />
        );
    }

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedExternalUser.fullName}
            onDialogClose={props.onCloseDialog}
            onOkClick={removeExternalUser}
            inProgress={inProgress}
        />
    );
}
